import * as $ from 'jquery';
import { ContractsApplication } from './ContractsApplication';

$(() => {
    const contractsApplication = $('[data-contract-templates-page]');
    if (contractsApplication.length === 0) {
        return;
    }

    let container = $(contractsApplication[0]);
    container.data('contractsApplication', new ContractsApplication(container));
});
